import { functionalUpdate, makeStateUpdater } from '@tanstack/react-table';

import type { OnChangeFn, RowData, TableFeature, Updater } from '@tanstack/react-table';

export type CompactModeState = boolean;

export interface CompactModeTableState {
  compactMode: CompactModeState;
}

export interface CompactModeOptions {
  onCompactModeChange?: OnChangeFn<CompactModeState>;
}

export interface CompactModeInstance {
  resetCompactMode: (defaultState?: CompactModeState) => void;
  setCompactMode: (updater: Updater<CompactModeState>) => void;
}

declare module '@tanstack/react-table' {
  interface TableState extends CompactModeTableState {}

  interface InitialTableState extends Partial<CompactModeTableState> {}

  interface TableOptionsResolved<TData extends RowData> extends CompactModeOptions {}

  interface Table<TData extends RowData> extends CompactModeInstance {}
}

export const TableCompactMode: TableFeature<unknown> = {
  getInitialState: (state): CompactModeTableState => ({ compactMode: false, ...state }),

  getDefaultOptions: table => ({
    onCompactModeChange: makeStateUpdater('compactMode', table),
  }),

  createTable: table => {
    table.setCompactMode = updater => {
      const safeUpdater: Updater<CompactModeState> = prev => {
        return functionalUpdate(updater, prev);
      };
      return table.options.onCompactModeChange?.(safeUpdater);
    };
    table.resetCompactMode = defaultState => {
      table.setCompactMode(defaultState ?? table.initialState.compactMode);
    };
  },
};
